import React from 'react';
import { ArrowRight } from 'lucide-react';
import { services } from '../mock';
import Reveal from './Reveal';

const Services = () => {
  return (
    <section id="hire" className="relative bg-[#262629] px-5 md:px-10 pt-6 md:pt-9 pb-24 z-20">
      <div className="max-w-[1400px] mx-auto">
        <p className="font-display text-white text-xl sm:text-2xl md:text-3xl tracking-wide text-center mb-6 md:mb-8">
          Have a project you need estimating? Here's what we estimate
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
        {services.map((s, i) => (
          <Reveal key={s.title.join(' ')} delay={i * 0.1}>
            <a
              href={s.href}
              className="group relative block h-[420px] rounded-2xl overflow-hidden"
            >
              <img
                src={s.img}
                alt={s.title.join(' ')}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-[#353539]/80 group-hover:bg-[#353539]/45 transition-colors duration-500" />
              <div className="relative z-10 h-full flex flex-col justify-between p-7">
                <h3 className="font-display text-white text-4xl xl:text-3xl 2xl:text-[38px] leading-[0.9] break-words">
                  {s.title.map((w, wi) => (
                    <React.Fragment key={wi}>{w}{wi < s.title.length - 1 && <br />}</React.Fragment>
                  ))}
                  {s.price && (
                    <span className="mt-2 block font-display text-white/90 text-sm md:text-base tracking-wide">
                      {s.price}
                    </span>
                  )}
                </h3>
                <div className="flex items-end justify-between gap-3">
                  <p className="text-white/90 text-base max-w-[78%] leading-snug">{s.desc}</p>
                  <span className="text-yellow transition-transform duration-300 group-hover:translate-x-1 shrink-0">
                    <ArrowRight className="w-8 h-8" strokeWidth={2.5} />
                  </span>
                </div>
              </div>
            </a>
          </Reveal>
        ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
